import { Link } from 'react-router-dom';

function TalktailApp() {
  return (
    <div className="p-10">
      <h2 className="text-3xl font-bold mb-4">Talktail 고객센터</h2>
      <p className="mb-6">이곳은 톡테일 고객센터입니다.</p>

      <div className="mb-6">
        <h3 className="text-xl font-semibold mb-2">고객지원 연락처</h3>
        <p>📍 &nbsp; 주소: 경북 경산시 삼풍로 27, 경북테크노파크 글로벌벤처동 309호</p>
        <p>📞 전화번호: 010-4898-5955</p>
        <p>✉️ 이메일: talktail@creamoff.co.kr</p>
      </div>

      <Link
        to="/talktailApp/privacy"
        className="text-blue-600 underline hover:text-blue-800"
      >
        개인정보 처리방침 보기
      </Link>
    </div>
  );
}

export default TalktailApp;
